<template>
  <section class="insider-promo" v-if="promo && product">
    <h2 class="insider-promo__title">Executive Series Webinar</h2>
    <!-- <div class="insider-promo__content"> -->
    <p class="insider-promo__description" v-html="promo.description" />
    <div class="insider-promo__cta">
      <button
        title="Click to copy the promo code."
        class="insider-promo__code-button"
        @click="attachToClipboard()"
      >
        {{ promo.promo_code }}
      </button>
      <BaseButton @click="checkout">REGISTER NOW</BaseButton>
    </div>
    <!-- </div> -->
  </section>
</template>

<script>
  import BaseButton from '~/components/base/BaseButton.vue';

  export default {
    name: 'InsiderPromo',
    components: {
      BaseButton,
    },
    props: {
      promo: {
        type: Object,
        required: false,
      },
      product: {
        type: Object,
        required: false,
      },
    },
    methods: {
      attachToClipboard() {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(this.promo.promo_code)
            .then(() => {
              this.$emit('site-notification', {
                message: 'Promo code copied to clipboard',
                color: 'success',
              });
            })
            .catch((error) => {
              this.$emit('site-notification', {
                message: 'Promo code was not copied to clipboard',
                color: 'danger',
              });
            });
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = this.promo.promo_code;
          document.body.appendChild(textarea);
          textarea.select();

          try {
            document.execCommand('copy');
          } catch (err) {
            this.$emit('site-notification', {
              message: 'Promo code was not copied to clipboard',
              color: 'danger',
            });
          } finally {
            document.body.removeChild(textarea);
          }
          this.$emit('site-notification', {
            message: 'Promo code copied to clipboard',
            color: 'success',
          });
        }
      },
      async checkout() {
        let cartResponse = await axios.post('/cart', {
          type: this.product.product_type.type,
          url: this.product.url,
          sku: this.product.sku,
          annual_sku: this.product.annual_sku,
          name: this.product.name,
          price: this.product.price,
          // promo_price: promoPrice, //not sure i need this but leaving it for now
          qty: 1,
          billing_period: this.product.billing_period,
          is_free_trial: this.product.is_free_trial,
          is_shipped: this.product.is_shipped,
          ounce_weight: this.product.ounce_weight,
          pound_weight: this.product.pound_weight,
        });

        let promoCodeResponse = await axios.post(
          `/cart/promo/${this.promo.promo_code}`
        );

        if (cartResponse.status === 201) {
          window.location.href = '/cart';
          return;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .insider-promo {
    position: relative;
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: repeat(12, 1fr);
    gap: 5px;
    height: 100%;
    overflow: hidden;
    padding: 10px 20px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--itr-blue-mid), var(--itr-blue));
    width: 100%;
    height: 133px;
    overflow: hidden;
    @include screen-sm {
      grid-template-rows: auto;
      align-items: center;
    }
    @include screen-md {
      width: 80%;
      height: 157px;
      align-items: unset;
    }
    @include screen-xl {
      padding: 12px;
      width: 450px;
      height: 181px;
      grid-template-rows: auto auto;
    }

    &__title {
      font-size: 20px;
      font-weight: 700;
      color: var(--itr-white);
      margin-bottom: 5px;
      text-decoration: underline;
      grid-row: 1;
      grid-column: 1 / span 12;
      @include screen-sm {
        grid-column: 1 / span 9;
      }
      @include screen-md {
        font-size: 25px;
        grid-column: 1 / span 12;
      }
    }
    &__description {
      color: var(--itr-white);
      font-size: 14px;
      display: none;
      max-height: 150px;
      overflow: hidden;
      width: 90%;
      @include screen-md {
        display: inline;
        grid-row: 2;
        grid-column: 1 / span 9;
      }
      @include screen-lg {
        grid-column: 1 / span 8;
      }
    }
    &__cta {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      grid-row: 2;
      grid-column: 1 / span 12;
      @include screen-sm {
        flex-direction: column;
        justify-content: center;
        width: unset;
        grid-row: 1;
        grid-column: 10 / span 12;
        gap: 10px;
      }
      @include screen-md {
        grid-row: 2;
        grid-column: 10 / span 12;
      }
      @include screen-lg {
        grid-column: 9 / span 12;
      }
    }
    &__code-button {
      color: var(--itr-white);
      font-weight: 700;
      font-size: 1.125rem;
      background-color: transparent;
      border: none;
      cursor: pointer;
    }
  }
</style>
